import { TFormField, TFormHook, TFormParams } from "../../@types/common";
import { FundSourceCard } from "../../components/elements/CardElements";
import { showConfetti } from "../../components/elements/ConfettiView";
import { reloadData } from "../../components/lists/ListHandler";
import { API_LOANS } from "../../constants/apis";
import { LOANS, REPAY, TEXT } from "../../constants/constants";
import { PropOptions } from "../../utils/formUtils";
import { transactionPinField } from "../../utils/pinUtils";
import { currencyFormat } from "../../utils/helpers";
import { useWallet } from "../wallets/useWallet";

export const useRepayForm = ({ state, form }: TFormParams): TFormHook => {
  const { id: loanId, remaining_balance } = state || {};
  const { getWalletBalance } = useWallet();

  const fields: TFormField[] = [
    {
      label: "repayment_amount",
      field: "amount",
      type: TEXT,
      required: true,
      props: {
        ...PropOptions.number,
        prefix: "UGX",
        helperText: `Maximum amount is ${currencyFormat(
          Math.ceil(remaining_balance)
        )}`,
        max: remaining_balance,
      },
    },
    transactionPinField as TFormField,
    {
      type: "component",
      component: <FundSourceCard />,
    },
  ];

  const onSubmit = ({ payload }: any) => {
    return {
      api: `${API_LOANS}${loanId}/${REPAY}/`,
      params: payload,
      onSuccess: () => {
        reloadData(LOANS);
        showConfetti();
        getWalletBalance();
      },
    };
  };

  const allowSubmit = parseInt(form?.amount) <= parseInt(remaining_balance);

  return {
    fields,
    onSubmit,
    submitText: REPAY,
    title: `${REPAY} Loan`,
    defaultValues: { amount: remaining_balance },
    allowSubmit,
  };
};
